package com.evoapps.evoshift.ui.util

import com.evoapps.evoshift.domain.model.DailyRecord
import com.evoapps.evoshift.domain.model.LabourBase
import com.evoapps.evoshift.ui.finance.formatPercent
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.chart_labor_share
import evoshift.composeapp.generated.resources.chart_labor_share_income
import evoshift.composeapp.generated.resources.daily_records_labor_income_plan
import evoshift.composeapp.generated.resources.daily_records_labor_income_real
import evoshift.composeapp.generated.resources.daily_records_labor_plan
import evoshift.composeapp.generated.resources.daily_records_labor_real
import evoshift.composeapp.generated.resources.dashboard_labor_cost_percent
import evoshift.composeapp.generated.resources.dashboard_labor_cost_percent_income
import evoshift.composeapp.generated.resources.financials_labor_value
import evoshift.composeapp.generated.resources.financials_labor_value_income
import evoshift.composeapp.generated.resources.labor_percentage
import evoshift.composeapp.generated.resources.labor_percentage_income
import org.jetbrains.compose.resources.StringResource

/*
 * SH-95: every labour % says what it is measured against: "of income" (the commission plus the
 * fixed revenue) for a workplace with a commission, "of sales" without one. Never one silently
 * for the other.
 */

/** "Labour % of income plan" / "Labour % of sales plan". */
fun labourPlanLabelRes(base: LabourBase): StringResource =
    if (base == LabourBase.INCOME) Res.string.daily_records_labor_income_plan else Res.string.daily_records_labor_plan

/** "Labour % of income actual" / "Labour % of sales actual". */
fun labourRealLabelRes(base: LabourBase): StringResource =
    if (base == LabourBase.INCOME) Res.string.daily_records_labor_income_real else Res.string.daily_records_labor_real

/** "Labour % of income" / "Labour % of sales". */
fun labourPercentLabelRes(base: LabourBase): StringResource =
    if (base == LabourBase.INCOME) Res.string.labor_percentage_income else Res.string.labor_percentage

/** "Labour 48% of income" / "Labour 12% of sales" (one argument: the percentage). */
fun labourValueRes(base: LabourBase): StringResource =
    if (base == LabourBase.INCOME) Res.string.financials_labor_value_income else Res.string.financials_labor_value

/** The owner dashboard's card title. */
fun labourCardTitleRes(base: LabourBase): StringResource =
    if (base == LabourBase.INCOME) Res.string.dashboard_labor_cost_percent_income else Res.string.dashboard_labor_cost_percent

/** The charts' labour share line. */
fun labourShareChartRes(base: LabourBase): StringResource =
    if (base == LabourBase.INCOME) Res.string.chart_labor_share_income else Res.string.chart_labor_share

/** A month of records: of income as soon as one of its days has a commission. */
fun Collection<DailyRecord>.labourBase(): LabourBase =
    if (any { it.labourBase == LabourBase.INCOME }) LabourBase.INCOME else LabourBase.SALES

/** "48%", or "-" without a value. */
fun formatPercentOrDash(value: Double?): String = value?.let { formatPercent(it) } ?: "-"
